import { colors, typography } from "../styles/theme.js";

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div
      style={{
        padding: 40,
        textAlign: "center",
        color: colors.textSecondary,
        fontSize: typography.fontSize.md,
      }}
    >
      <div
        style={{
          display: "inline-block",
          width: 20,
          height: 20,
          border: `3px solid ${colors.border}`,
          borderTopColor: colors.primary,
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <div style={{ marginTop: 12 }}>{message}</div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;
